var map = {
	"./music-instructions.json": 4966,
	"./music-library-intro2024.json": 4967,
	"./music-library-launch2024.json": 4968,
	"./music-progression.json": 4969,
	"./startSourcesAdvanced.json": 4970,
	"./startSourcesSimple.json": 4971,
	"./startSourcesSimple2.json": 4972,
	"./startSourcesTracks.json": 4973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4735;